import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { DATA_TYPE } from "../../../constants";
import { getNestedError } from "../../../utils";

const MyTextField = (props) => {
  const {
    name,
    hint = "",
    debounce = 0,
    icon,
    dataType = "text",
    dense = false,
    onChange = () => {},
    onBlur = () => {},
    className = "",
    outlined = true,
    inputClass = "",
    inputStyle = {},
    ...rest
  } = props;

  const [isFocus, setIsFocus] = useState(false);

  const {
    trigger,
    register,
    setValue,
    watch,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const value = watch(name);

  const useDebounce = (callback, delay) => {
    let timeout;
    return (...args) => {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  };

  const debouncedOnChange = useDebounce((value) => {
    setValue(name, value);
    onChange(value);
  }, debounce);

  const handleKeyDown = (e) => {
    let newValue = e.target.value;

    if (dataType === DATA_TYPE.INTEGER) {
      if (
        !/[-0-9]/.test(e.key) &&
        !["Backspace", "ArrowLeft", "ArrowRight", "Delete"].includes(e.key)
      ) {
        e.preventDefault();
      }
      if (e.key === "-" && newValue.includes("-")) {
        e.preventDefault();
      }
    }

    if (dataType === DATA_TYPE.FLOAT) {
      if (
        !/[-0-9.]/.test(e.key) &&
        !["Backspace", "ArrowLeft", "ArrowRight", "Delete"].includes(e.key)
      ) {
        e.preventDefault();
      }
      if (e.key === "." && newValue.includes(".")) {
        e.preventDefault();
      }
      if (e.key === "-" && newValue.includes("-")) {
        e.preventDefault();
      }
    }
  };

  const handleChange = (e) => {
    let newValue = e.target.value;

    if (dataType === DATA_TYPE.INTEGER) {
      newValue = newValue.replace(/[^0-9-]/g, "");

      if (newValue.indexOf("-") > 0) {
        newValue = newValue.replace(/-/g, "");
        newValue = "-" + newValue;
      }
    }
    if (dataType === DATA_TYPE.FLOAT) {
      newValue = newValue.replace(/[^0-9.-]/g, "");
      if (newValue.indexOf("-") > 0) {
        newValue = newValue.replace(/-/g, "");
        newValue = "-" + newValue;
      }

      const dotCount = (newValue.match(/\./g) || []).length;
      if (dotCount > 1) {
        newValue = newValue.slice(0, newValue.lastIndexOf(".") + 1);
      }
    }
    debouncedOnChange(newValue);
  };

  useEffect(() => {
    if (value) trigger(name);
    else clearErrors(name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className={className}>
      <div
        className={`${
          outlined ? "border rounded" : "border-b"
        }  flex items-center gap-2 ${!dense ? "px-4 h-[56px]" : "px-2 h-9"} ${
          !rest.disabled ? "bg-white" : "bg-[#F5F5F5]"
        } ${
          getNestedError(errors, name)
            ? "border-error"
            : isFocus
            ? "border-primary"
            : "border-gray-border"
        } ${inputClass}`}
        style={{
          transition: "all 0.2s ease",
          ...inputStyle,
        }}
      >
        <input
          {...rest}
          {...register(name)}
          className={`flex-1 w-full border-none outline-none bg-transparent ${
            !dense ? "md:text-base text-sm" : "text-sm"
          }`}
          onFocus={() => setIsFocus(true)}
          onBlur={() => {
            setIsFocus(false);
            onBlur();
          }}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
        {icon && icon}
      </div>
      {(getNestedError(errors, name) || hint) && (
        <p
          className={`text-sm ${
            getNestedError(errors, name) ? "text-error" : "text-[#999]"
          }`}
        >
          {getNestedError(errors, name)
            ? getNestedError(errors, name).message
            : hint}
        </p>
      )}
    </div>
  );
};

export default MyTextField;
